const { m } = require('minthril');
const { ProductCard } = require('../../productCard');

function ProductsPage() {
  return {
    view: ({ attrs: { products, collections = [], onAdd, cartQuantities = {}, redraw } }) => m(Catalog, { products, collections, onAdd, cartQuantities, redraw })
  };
}

function Catalog() {
  let search = '';
  let selectedCategory = 'All parts';
  let filtersOpen = false;

  return {
    view: ({ attrs: { products, collections, onAdd, cartQuantities, redraw } }) => {
      const visibleCollections = collections.filter(collection => collection.title.toLowerCase() !== 'home page');
      const collectionNames = visibleCollections.map(collection => collection.title);
      const categories = ['All parts', ...collectionNames];
      const searchTerm = search.toLowerCase().trim();
      const matchingProducts = products.filter(product => {
        const collection = visibleCollections.find(item => item.title === selectedCategory);
        const belongsToCollection = collection?.products.nodes.some(item => item.id === product.id);
        return (selectedCategory === 'All parts' || belongsToCollection) &&
          (!searchTerm || product.title.toLowerCase().includes(searchTerm));
      });

      return m('section.catalog',
        m('div.catalog__intro',
          m('p.products__eyebrow', 'The catalogue'),
          m('h1.products__heading', 'All parts'),
          m('p.products__description', 'Browse the complete collection of considered components and upgrades.'),
          m('p.catalog__browse-mode', 'Prefer to browse by collection? ',
            m('a', { href: '/collections' }, 'Go to collections →')
          )
        ),
        m('div.catalog__layout',
          m('button.catalog__filter-toggle', { type: 'button', onclick: () => { filtersOpen = !filtersOpen; redraw(); } }, filtersOpen ? 'Hide filters' : 'Filter parts'),
          m(`aside.catalog__toc${filtersOpen ? '.is-open' : ''}`, m('p.catalog__toc-title', 'Contents'), categories.map(category => m('button.catalog__filter', { class: selectedCategory === category ? 'is-active' : '', onclick: () => { selectedCategory = category; redraw(); } }, category))),
          m('div.catalog__results', m('label.catalog__search', m('span', 'Search parts'), m('input', { type: 'search', placeholder: 'Search by name', value: search, oninput: event => { search = event.target.value; redraw(); } })), m('p.catalog__count', `${matchingProducts.length} result${matchingProducts.length === 1 ? '' : 's'}`), m('div.products__grid products__grid--list', matchingProducts.map(product => m(ProductCard, { key: product.id, product, onAdd, cartQuantity: cartQuantities[product.variants.nodes[0]?.id] || 0, variant: 'list' }))))
        )
      );
    }
  };
}

module.exports = { ProductsPage };
